export default __webpack_public_path__ + "static/media/Boys_Head_Bounce.4c8fabca.svg";